
<div class="box-counter">
    <div class="loading">
        <svg xmlns="http://www.w3.org/2000/svg" width="124" height="124" viewBox="0 0 124 124">
        <circle class="circle-loading" cx="62" cy="62" r="59" fill="none" stroke-width="6px"></circle>
        <circle class="circle" [id]="this.createdAtOrder" [style]="{'stroke-dashoffset': this.dashoffset}" cx="62" cy="62" r="59" fill="none" stroke="var(--primary-color)" stroke-width="6px" stroke-linecap="round"></circle>
        </svg>

        <div class="counter" *ngIf="this.start">
            <span class="counter-content" [ngStyle]="{'font-size': this.fontSize}">
                <span>0{{ this.counterMin }}</span>
                :
                <span *ngIf="this.counterSec >= 10">{{ this.counterSec }}</span>
                <span *ngIf="this.counterSec < 10">0{{ this.counterSec }}</span>
            </span>
        </div>
    </div>
</div>